import { LlmPanelData } from './types'

const LATEST_DATA_SCHEMA_VERSION = 1

export const DEFAULT_LLM_PANEL_DATA: LlmPanelData = {
  title: 'AI Helper',
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  isPinned: true,
  messages: [],
  settings: {
    showTimestamps: false,
    sidebarCollapsed: false,
  },
}
